import React, { useState } from "react";
import { Form, Row, Col, Button, InputGroup } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../superAdmin/editProfile.css";
// Example dynamic data for dropdowns
const sectors = ["Technology", "Healthcare", "Finance", "Education"];
const countries = ["USA", "Canada", "UK", "Germany"];
const cities = {
  USA: ["New York", "Los Angeles", "Chicago"],
  Canada: ["Toronto", "Vancouver", "Montreal"],
  UK: ["London", "Manchester", "Birmingham"],
  Germany: ["Berlin", "Munich", "Frankfurt"],
};

const EditProfileForm = ({ user, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    name: user?.name || "",
    email: user?.email || "",
    // ownerName1: user?.ownerName1 || "",
    // ownerName2: user?.ownerName2 || "",
    // sector: user?.sector || "",
    country: user?.country || "",
    city: user?.city || "",
    address: user?.address || "",
    mobile_number: user?.mobile_number || "",
  });

  const [showPassword, setShowPassword] = useState(false);

  // Handle dropdown-dependent cities
  const handleCountryChange = (e) => {
    setFormData({ ...formData, country: e.target.value, city: "" });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData); // Pass updated data back to parent
  };

  return (
    <Form onSubmit={handleSubmit} className="pt-4">
      <Row>
        {/* Name */}
        <Col lg={4} md={6}>
          <Form.Group controlId="name" className="my-1">
            <Form.Label>
              Name <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter name"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              required
            />
          </Form.Group>
        </Col>

        {/* Email */}
        <Col lg={4} md={6}>
          <Form.Group controlId="email" className="my-1">
            <Form.Label>
              Email <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter email"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
              required
            />
          </Form.Group>
        </Col>

        {/* Owner Name 1 */}
        {/* <Col lg={4} md={6}>
          <Form.Group controlId="ownerName1" className="my-1">
            <Form.Label>Owner Name 1</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter owner name 1"
              value={formData.ownerName1}
              onChange={(e) =>
                setFormData({ ...formData, ownerName1: e.target.value })
              }
            />
          </Form.Group>
        </Col> */}

        {/* Owner Name 2 */}
        {/* <Col lg={4} md={6}>
          <Form.Group controlId="ownerName2" className="my-1">
            <Form.Label>Owner Name 2</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter owner name 2"
              value={formData.ownerName2}
              onChange={(e) =>
                setFormData({ ...formData, ownerName2: e.target.value })
              }
            />
          </Form.Group>
        </Col> */}

        {/* Sector */}
        {/* <Col lg={4} md={6}>
          <Form.Group controlId="sector" className="my-1">
            <Form.Label>Sector</Form.Label>
            <Form.Control
              as="select"
              value={formData.sector}
              onChange={(e) =>
                setFormData({ ...formData, sector: e.target.value })
              }
            >
              <option value="">Select sector</option>
              {sectors.map((sector, index) => (
                <option key={index} value={sector}>
                  {sector}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </Col> */}

        {/* Country */}
        {/* <Col lg={4} md={6}>
          <Form.Group controlId="country" className="my-1">
            <Form.Label>Country</Form.Label>
            <Form.Control
              as="select"
              value={formData.country}
              onChange={handleCountryChange}
            >
              <option value="">Select country</option>
              {countries.map((country, index) => (
                <option key={index} value={country}>
                  {country}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </Col> */}
        <Col lg={4} md={6}>
          <Form.Group controlId="country" className="my-1">
            <Form.Label>
              Country <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter country"
              value={formData.country}
              onChange={(e) =>
                setFormData({ ...formData, country: e.target.value })
              }
            />
          </Form.Group>
        </Col>

        {/* City */}
        {/* <Col lg={4} md={6}>
          <Form.Group controlId="city" className="my-1">
            <Form.Label>City</Form.Label>
            <Form.Control
              as="select"
              value={formData.city}
              onChange={(e) =>
                setFormData({ ...formData, city: e.target.value })
              }
              disabled={!formData.country}
            >
              <option value="">Select city</option>
              {formData.country &&
                cities[formData.country].map((city, index) => (
                  <option key={index} value={city}>
                    {city}
                  </option>
                ))}
            </Form.Control>
          </Form.Group>
        </Col> */}
        <Col lg={4} md={6}>
          <Form.Group controlId="city" className="my-1">
            <Form.Label>
              City <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter city"
              value={formData.city}
              onChange={(e) =>
                setFormData({ ...formData, city: e.target.value })
              }
            />
          </Form.Group>
        </Col>
        {/* Address */}
        <Col lg={4} md={6}>
          <Form.Group controlId="address" className="my-1">
            <Form.Label>Address</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter address"
              value={formData.address}
              onChange={(e) =>
                setFormData({ ...formData, address: e.target.value })
              }
            />
          </Form.Group>
        </Col>

        {/* Phone */}
        {/* <Col lg={4} md={6}>
          <Form.Group controlId="phone" className="my-1">
            <Form.Label>Phone</Form.Label>
            <InputGroup>
              <Form.Control
                as="select"
                style={{ maxWidth: "100px" }}
                value={formData.phoneCountryCode || "+1"}
                onChange={(e) => {
                  const newPhoneCountryCode = e.target.value;

                  setFormData((prevData) => {
                    // Update the country code and the full phone number
                    const updatedFullPhoneNumber = `${newPhoneCountryCode}${
                      prevData.mobile_number || ""
                    }`;
                    return {
                      ...prevData,
                      phoneCountryCode: newPhoneCountryCode,
                      mobile_number: updatedFullPhoneNumber, // Store full phone number in mobile_number key
                    };
                  });
                }}
              >
                <option value="+1">+1 (USA)</option>
                <option value="+44">+44 (UK)</option>
                <option value="+49">+49 (Germany)</option>
                <option value="+91">+91 (India)</option>
                <option value="+92">+92 (Pakistan)</option>
              </Form.Control>


              <Form.Control
                type="text"
                placeholder="Enter phone"
                value={
                  formData.mobile_number?.slice(
                    formData.phoneCountryCode?.length
                  ) || ""
                }
                onChange={(e) => {
                  const numericValue = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                  const limitedValue = numericValue.slice(0, 10); // Restrict to 10 digits

                  setFormData((prevData) => {
                    // Update the mobile number and the full phone number
                    const updatedFullPhoneNumber = `${
                      prevData.phoneCountryCode || "+1"
                    }${limitedValue}`;
                    return {
                      ...prevData,
                      mobile_number: updatedFullPhoneNumber, // Store full phone number in mobile_number key
                    };
                  });
                }}
              />
            </InputGroup>
          </Form.Group>
        </Col> */}
        <Col lg={4} md={6}>
          <Form.Group controlId="phone" className="my-1">
            <Form.Label>Phone</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter phone"
              value={formData.mobile_number}
              onChange={(e) => {
                const validValue = e.target.value.replace(/[^0-9+() -]/g, ""); // Allow only numbers, +, (), and -
                setFormData({ ...formData, mobile_number: validValue });
              }}
            />
          </Form.Group>
        </Col>
      </Row>

      {/* Buttons */}
      <Form.Group className="text-end mt-4">
        <Button
          variant="outline-success"
          className="cancel-button mx-2"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button type="submit" className="button">
          Submit
        </Button>
      </Form.Group>
    </Form>
  );
};

export default EditProfileForm;
